import { LANDING_PAGE_EVENTS, LANDING_PAGE_SECTIONS_NAMES } from 'Utilities/analytics';

export const TERMS_LINK = '/blog/2026/08/17/aug-car-prize-draw';

export const CAR_PRIZE_DRAW_ANALYTICS_LABEL = 'car_prize_draw';

type SectionName = typeof LANDING_PAGE_SECTIONS_NAMES[keyof typeof LANDING_PAGE_SECTIONS_NAMES];

export const carPrizeDrawSectionLoadEvent = (name: SectionName) => LANDING_PAGE_EVENTS.SECTION_LOAD({
  label: CAR_PRIZE_DRAW_ANALYTICS_LABEL,
  name,
});
